module.exports = __webpack_public_path__ + "static/create-magic-05cc9ef4a344ccc2fde620569866b68d.png";